// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"404":"ac9721d3","524":"f79604b6","718":"e32b8c8f"}[chunkId] + ".js";
};